document.addEventListener("DOMContentLoaded", function() {
  let track = document.querySelector(".vanta-track");
  let cars = document.querySelectorAll(".vanta-car");
  let index = 0;

  function update() {
    cars.forEach(c => c.classList.remove("active"));
    cars[index].classList.add("active");
    track.style.transform = "translateX(" + (-index * 580) + "px)";
  }

  document.querySelector(".right").onclick = function() {
    index = (index + 1) % cars.length;
    update();
  };

  document.querySelector(".left").onclick = function() {
    index = (index - 1 + cars.length) % cars.length;
    update();
  };

  update();
});